module.exports = ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}"